import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AppStateFacade } from '@app-state';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@services';
import { UiSnackBarService } from '@uipath/angular/components/ui-snackbar';
import UiValidators, {
    UI_EMAIL_MAX_LENGTH,
    UI_NAME_LONG_MAX_LENGTH,
} from '@validators';

import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
    templateUrl: 'password-reset.page.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class PasswordResetPageComponent {
    public loading$ = new BehaviorSubject(false);
    public form: FormGroup;

    constructor(
        fb: FormBuilder,
        public auth: AuthService,
        private _router: Router,
        private _cd: ChangeDetectorRef,
        private _translateService: TranslateService,
        private _snack: UiSnackBarService,
        appState: AppStateFacade,
    ) {
        if (!appState.authConfig.value.cloud.allowPasswordChange) {
            _router.navigate(['/account/login']);
        }

        this.form = fb.group({
            'tenancyName': [
                '',
                Validators.maxLength(UI_NAME_LONG_MAX_LENGTH),
            ],
            'usernameOrEmailAddress': [
                '',
                Validators.compose([
                    Validators.required,
                    UiValidators.whitespace,
                    Validators.maxLength(UI_EMAIL_MAX_LENGTH),
                ]),
            ],
        });
    }

    public onSubmit(event: Event) {
        event.preventDefault();

        if (!this.form.valid) {
            return;
        }

        this.loading$.next(true);

        this.auth.forgotPassword(this.form.value)
            .pipe(
                finalize(
                    () => this.loading$.next(false),
                ),
            )
            .subscribe(() => {
                this._snack.success(this._translateService.instant('password_reset_succes_message'));
                this._cd.markForCheck();
                this._router.navigate(['/account/login']);
            });
    }
}
